import React from 'react';
import { number } from '../../../Common/Util/number';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import TableComponent from '../../../Common/Charts/TableCharts';

export const Table = () => {
    const { chartData } = useServicesChartsDataContext();

    const columns = [
        {
            key: 'type',
            header: 'Código',
            headerStyle: {
                fontWeight: '500',
                width: '20%'
            },
            cellStyle: {}
        },
        {
            key: 'description',
            header: 'CID',
            headerStyle: {
                fontWeight: '500',
                width: '50%'
            },
            cellStyle: {}
        },
        {
            key: 'services',
            header: 'Total de atendimentos - CID Principal',
            headerStyle: {
                fontWeight: '500',
                textAlign: 'right',
                width: '30%'
            },
            cellStyle: {
                textAlign: 'right'
            },
            formatter: (value) => number.formatToBRNumber(value)
        }
    ];

    const calculateTotals = (data) => {
        if (!data || !Array.isArray(data)) return null;
        return {
            type: 'Total',
            description: '',
            services: data.reduce((acc, curr) => acc + Number(curr.services || 0), 0)
        };
    };

    const tableData = React.useMemo(() => {
        if (!chartData?.counterByCID) return [];

        const data = [...chartData.counterByCID];
        const totals = calculateTotals(data);

        if (totals) {
            data.push(totals);
        }

        return data;
    }, [chartData?.counterByCID]);

    return (
        <div className="chart-container-dashboards">
            <TableComponent
                data={tableData}
                columns={columns}
                title="Informações de Procedimentos"
                showTotal={false}
                maxHeight="400px"
                className="w-100"
                isLastTotal
            />
        </div>
    );
};